<template>
    <div class="card">
        <Toast />
        <form>
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field d-flex">
                            <label for="title2" id="switch"
                                ><b id="tab">{{ $t('Packages.Edit.Active') }}</b></label
                            >
                            <InputSwitch v-model="details.status" trueValue="active" @change="switchValue(id, status)" />
                            <!-- <InputSwitch v-model="details.status" trueValue="active" /> -->
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.PackageInfo') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-3 p-mb-lg-0 p-field">
                            <label for="title2"
                                ><b>{{ $t('Packages.Edit.PackageName') }}</b></label
                            >
                            <InputText :class="`${error.name ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Packages.Edit.PackageName')" id="desc1" v-model="details.name"> </InputText>
                            <div class="text-red">{{ error.name }}</div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field">
                            <label for="title2"
                                ><b>{{ $t('Packages.Edit.PackageGuide') }}</b></label
                            >
                            <Textarea :class="`${error.description ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Packages.Edit.PackageGuide')" id="desc1" v-model="details.description"></Textarea>
                            <div class="text-red">{{ error.description }}</div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading2') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="subtitle2">
                                <b>{{ $t('Packages.Edit.Pic') }}</b>
                                <span class="img-info">(File Type jpg,jpeg,png )</span>
                            </label>
                            <div :class="`${error.file ? 'custom-select-invalid' : 'custom-select'}`">
                                <span v-if="!fileName">{{ $t('Packages.Edit.Selectfile') }}</span>
                                <span v-else>{{ fileName }}</span>
                                <input type="file" class="select-file" v-on:change="onFileChange" />
                                <Button :label="$t('Packages.Edit.select_file')" class="SelectBtn n-wrap" />
                            </div>
                            <label for="subtitle2">{{ $t('Packages.Edit.File') }}</label
                            ><br />
                            <!-- <div class="text-red">{{ error.file }}</div> -->
                            <div class="text-red" v-show="render1">{{ $t('validation.invalidFile') }}</div>
                            <div class="text-red" v-show="render2">파일이 너무 큽니다</div>
                            <Image :src="details.image_url" alt="이미지를 사용할 수 없음" class="product-image" width="137" height="85" preview />
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-12 p-mb-lg-0 p-field" id="desc1">
                            <label for="title2"
                                ><b>{{ $t('Packages.Edit.GuideModal') }}</b></label
                            >
                            <Textarea :class="`${error.modal_info ? 'p-invalid' : ''}`" type="text" :placeholder="$t('Packages.Edit.GuideModal')" id="desc1" v-model="details.modal_info"></Textarea>
                            <div class="text-red">{{ error.modal_info }}</div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading3') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.OriginalPrice') }}</label>
                            <InputText type="text" :class="`${error.original_price ? 'p-invalid' : ''}`" :placeholder="$t('Packages.Edit.OriginalPrice')" id="title2" v-model="details.original_price" @change="getpercentage"> </InputText>
                            <div class="text-red">{{ error.original_price }}</div>
                        </div>

                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('Packages.Edit.DiscountRate') }}</label>
                            <InputText type="text" :class="`${error.discount ? 'p-invalid' : ''}`" :placeholder="$t('Packages.Edit.DiscountRate')" id="title2" v-model="details.discount" @change="getpercentage"></InputText>
                            <div class="text-red">{{ error.discount }}</div>
                            <!-- <Dropdown id="state2" v-model="mydata.status" :options="dropdownValues" optionLabel="name" :placeholder="mydata.status" /> -->
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="state2">{{ $t('Packages.Edit.Offeredprice') }}</label>
                            <InputText type="text" :class="`${error.discounted_price ? 'p-invalid' : ''}`" :placeholder="$t('Packages.Edit.Offeredprice')" id="title2" v-model="details.discounted_price" disabled> </InputText>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading4') }}</b>
                    </h5>

                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Category') }}</label>
                            <select v-model="select" @change="getSubTypes($event)" class="DualDisplay1">
                                <!-- education level  -->
                                <option v-for="option in Typesdropdown" v-bind:value="option.id" :key="option.value">
                                    {{ option.ad_type == 'emergency' ? '긴급' : option.ad_type == 'premium' ? '프리미엄' : option.ad_type == 'special' ? '스페셜' : option.ad_type == 'line' ? '라인' : '' }}
                                </option>
                            </select>
                            <div class="text-red">{{ error.ad_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.ValidTime') }}</label>
                            <select v-model="subselect" class="DualDisplay1" @change="addField(select, subselect)">
                                <!-- education level -->
                                <option v-for="option in SubTypesdropdown" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <!-- <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label> -->
                            <div id="dualBtns" class="p-mt-25">
                                <!-- <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label> -->
                                <Button :label="$t('Chodan.Edit.Add')" icon="pi pi-plus" iconPos="left" class="p-button p-button p-mr-2" @click="isHidden = true" id="Save"></Button>
                            </div>
                        </div>
                    </div>

                    <div class="p-grid p-formgrid p-mb-3" v-if="isHidden">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Category') }}</label>
                            <select v-model="select1" @change="getSubTypes1($event)" class="DualDisplay1" @select="addField1(select1, subselect1)">
                                <!-- education level  -->
                                <option v-for="option in Typesdropdown" v-bind:value="option.id" :key="option.value">
                                    {{ option.ad_type == 'emergency' ? '긴급' : option.ad_type == 'premium' ? '프리미엄' : option.ad_type == 'special' ? '스페셜' : option.ad_type == 'line' ? '라인' : '' }}
                                </option>
                            </select>
                            <div class="text-red">{{ error.ad_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.ValidTime') }}</label>
                            <select v-model="subselect1" class="DualDisplay1" @change="addField1(select1, subselect1)">
                                <!-- education level -->
                                <option v-for="option in SubTypesdropdown1" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <div id="dualBtns" class="p-mt-25">
                                <!-- <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label> -->
                                <Button :label="$t('Chodan.Edit.Add')" icon="pi pi-plus" iconPos="left" class="p-button p-button p-mr-2" @click="isHidden1 = true" id="Save"></Button>
                                <Button
                                    :label="$t('Chodan.Edit.Delete')"
                                    icon="pi pi-trash"
                                    iconPos="left"
                                    class="p-button p-button-outlined p-button p-mr-2"
                                    @click="removeField1(select1, subselect1)"
                                    id="Save"
                                    style="background: white; color: black"
                                ></Button>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3" v-if="isHidden1">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Category') }}</label>
                            <select v-model="select2" @change="getSubTypes2($event)" class="DualDisplay1">
                                <!-- education level  -->
                                <option v-for="option in Typesdropdown" v-bind:value="option.id" :key="option.value">
                                    {{ option.ad_type == 'emergency' ? '긴급' : option.ad_type == 'premium' ? '프리미엄' : option.ad_type == 'special' ? '스페셜' : option.ad_type == 'line' ? '라인' : '' }}
                                </option>
                            </select>
                            <div class="text-red">{{ error.ad_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.ValidTime') }}</label>
                            <select v-model="subselect2" class="DualDisplay1" @change="addField2(select2, subselect2)">
                                <!-- education level -->
                                <option v-for="option in SubTypesdropdown2" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <div id="dualBtns" class="p-mt-25">
                                <!-- <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label> -->
                                <Button :label="$t('Chodan.Edit.Add')" icon="pi pi-plus" iconPos="left" class="p-button p-button p-mr-2" @click="isHidden2 = true" id="Save"></Button>
                                <Button
                                    :label="$t('Chodan.Edit.Delete')"
                                    icon="pi pi-trash"
                                    iconPos="left"
                                    class="p-button p-button-outlined p-button p-mr-2"
                                    @click="removeField2(select2, subselect2)"
                                    id="Save"
                                    style="background: white; color: black"
                                ></Button>
                            </div>
                        </div>
                    </div>
                    <div class="p-grid p-formgrid p-mb-3" v-if="isHidden2">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Category') }}</label>
                            <select v-model="select3" @change="getSubTypes3($event)" class="DualDisplay1">
                                <!-- education level  -->
                                <option v-for="option in Typesdropdown" v-bind:value="option.id" :key="option.value">
                                    {{ option.ad_type == 'emergency' ? '긴급' : option.ad_type == 'premium' ? '프리미엄' : option.ad_type == 'special' ? '스페셜' : option.ad_type == 'line' ? '라인' : '' }}
                                </option>
                            </select>
                            <div class="text-red">{{ error.ad_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.ValidTime') }}</label>
                            <select v-model="subselect3" class="DualDisplay1" @change="addField3(select3, subselect3)">
                                <!-- education level -->
                                <option v-for="option in SubTypesdropdown3" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <div id="dualBtns" class="p-mt-25">
                                <!-- <label for="subtitle2" id="match" style="color: transparent; opacity: 0"> 0 </label> -->
                                <!-- <Button :label="$t('Chodan.Edit.Add')" icon="pi pi-plus" iconPos="left" class="p-button p-button p-mr-2" @click="addField3(select3, subselect3)" id="Save"></Button> -->
                                <Button
                                    :label="$t('Chodan.Edit.Delete')"
                                    icon="pi pi-trash"
                                    iconPos="left"
                                    class="p-button p-button-outlined p-button p-mr-2"
                                    @click="removeField3(select3, subselect3)"
                                    id="Save"
                                    style="background: white; color: black"
                                ></Button>
                            </div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading5') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Days') }}</label>
                            <select v-model="sub2" class="DualDisplay1" @change="GetSubID(sub2)">
                                <!-- education level -->
                                <option v-for="option in UpgleTypesdropdown" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                    </div>
                    <h5>
                        <b>{{ $t('Packages.Edit.Heading6') }}</b>
                    </h5>
                    <div class="p-grid p-formgrid p-mb-3">
                        <div class="p-col-12 p-mb-2 p-lg-4 p-mb-lg-0 p-field">
                            <label for="title2">{{ $t('Packages.Edit.Nocases') }} & {{ $t('Packages.Edit.Time') }}</label>
                            <select v-model="sub3" class="DualDisplay1" @change="GetSubID2(sub3)">
                                <!-- education level -->
                                <option v-for="option in TalentTypesdropdown" v-bind:value="option.id" :key="option.value">{{ option.sub_type }} - {{ option.no_of_cases }} Cases - {{ option.validity_date }} Days</option>
                            </select>
                            <div class="text-red">{{ error.ad_sub_type_id }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: left">
                <ConfirmPopup group="popup"></ConfirmPopup>
                <Button :label="$t('Chodan.Edit.Save')" icon="pi pi-check" iconPos="left" class="p-button p-button p-mr-2 p-mb-2" @click="LengthCheck()" id="Save"></Button>
            </div>
            <div class="p-d-flex p-jc-end p-ai-center" style="float: right">
                <Button :label="$t('Chodan.Edit.Back')" icon="pi pi-replay" iconPos="left" class="p-button p-button-outlined p-button p-mr-2 p-mb-2" @click="$router.go(-1)" style="background: white; color: black"> </Button>
            </div>
            <br /><br />
        </form>
    </div>
</template>

<script>
import validateEditPackage from '../../../validations/PackageManagement/validateEditPackage';
import PackageService from '../../../service/API/PackageService';
import axios from 'axios';
import Swal from 'sweetalert2';
export default {
    data() {
        return {
            loading1: false,
            isHidden: false,
            isHidden1: false,
            isHidden2: false,
            products: null,
            expandedRows: [],
            results: [],
            render2: false,

            dropdownItem: null,
            error: {},
            //params for list
            name: '',
            status: '',
            email: '',
            phone_number: '',
            user: {
                menus: [],
            },
            fileName: '',
            fileExtension: '',
            filesExtension: '',
            files: '',
            filesName: '',
            file: '',
            modal_image: '',
            image: '',
            Typesdropdowns: '',
            Typesdropdown: [],
            SubTypesdropdown: [],
            SubTypesdropdowns: '',
            SubTypesdropdown1: [],
            SubTypesdropdowns1: '',
            SubTypesdropdown2: [],
            SubTypesdropdowns2: '',
            SubTypesdropdown3: [],
            SubTypesdropdowns3: '',
            UpgleTypesdropdown: [],
            UpgleTypesdropdowns: '',
            TalentTypesdropdown: [],
            TalentTypesdropdowns: '',
            phoneNumbers: [{ phone: '' }],
            details: {
                name: '',
                description: '',
                modal_info: '',
                image_url: '',
                original_price: '',
                discount: '',
                discounted_price: '',
                status: '',
                created_at: '',
                updated_at: '',
            },
            ad_type_id: '',
            grouparray: [],
            ad_sub_type_id: '',
            sub_type: '',
            validity_date: '',
            render1: false,
            select: '',
            subselect: '',
            select1: '',
            subselect1: '',
            select2: '',
            subselect2: '',
            select3: '',
            subselect3: '',
            sub2: '',
            sub3: '',
            package_items: [],
            PackageItems: [],
            last_package_item: [],
            selected_items: [],
            default_values: '',
            formData: new FormData(),
        };
    },
    // customerService: null,
    AdminService: null,
    created() {
        this.packageService = new PackageService();
    },
    mounted() {
        this.default_values = 'mounted';
        this.packageService.GetAddTypeList().then((data) => {
            this.Typesdropdown = data.data.result;
            this.loading1 = false;
            console.log(this.Typesdropdown);
        });
        // this.getFRlist();
        this.packageService.viewPackage(this.$route.params.id).then((res) => {
            console.log('viewPackage---', res);
            let arr = res.package_items;
            arr.map((item) => {
                if ([6, 7].includes(item.ad_type_id)) {
                    this.last_package_item.push(item);
                } else {
                    this.PackageItems.push(item);
                }
            });
            this.details.name = res.package[0].name;
            this.details.status = res.package[0].status;
            this.details.image_url = res.package[0].image_url;
            this.details.description = res.package[0].description;
            this.details.discount = res.package[0].discount;
            this.details.modal_info = res.package[0].modal_info;
            this.details.discounted_price = res.package[0].discounted_price;
            this.details.original_price = res.package[0].original_price;
            // this.PackageItems = res.package_items;
            console.log(this.PackageItems);
            console.log(this.PackageItems.length);
            if (this.PackageItems.length === 1) {
                this.select = res.package_items[0].ad_type_id;
                this.getSubTypes();
                this.subselect = res.package_items[0].ad_sub_type_id;
                this.last_package_item.map(() => {
                    this.sub2 = res.package_items[1].ad_sub_type_id;
                    this.sub3 = res.package_items[2].ad_sub_type_id;
                });
                this.isHidden = false;
            } else if (this.PackageItems.length === 2) {
                this.select = res.package_items[0].ad_type_id;
                this.getSubTypes();
                this.subselect = res.package_items[0].ad_sub_type_id;
                this.select1 = res.package_items[1].ad_type_id;
                this.getSubTypes1();
                this.subselect1 = res.package_items[1].ad_sub_type_id;
                this.last_package_item.map(() => {
                    this.sub2 = res.package_items[2].ad_sub_type_id;
                    this.sub3 = res.package_items[3].ad_sub_type_id;
                });
                this.isHidden = true;
                // this.isHidden1 = true;
            } else if (this.PackageItems.length === 3) {
                this.select = res.package_items[0].ad_type_id;
                this.getSubTypes();
                this.subselect = res.package_items[0].ad_sub_type_id;

                this.select1 = res.package_items[1].ad_type_id;
                this.getSubTypes1();
                this.subselect1 = res.package_items[1].ad_sub_type_id;

                this.select2 = res.package_items[2].ad_type_id;
                this.getSubTypes2();
                this.subselect2 = res.package_items[2].ad_sub_type_id;
                this.last_package_item.map(() => {
                    this.sub2 = res.package_items[3].ad_sub_type_id;
                    this.sub3 = res.package_items[4].ad_sub_type_id;
                    console.log('Last Items--', this.sub2);
                });
                console.log('Last Items--', this.last_package_item);
                this.isHidden = true;
                this.isHidden1 = true;
            } else if (this.PackageItems.length === 4) {
                this.select = res.package_items[0].ad_type_id;
                this.getSubTypes();
                this.subselect = res.package_items[0].ad_sub_type_id;

                this.select1 = res.package_items[1].ad_type_id;
                this.getSubTypes1();
                this.subselect1 = res.package_items[1].ad_sub_type_id;

                this.select2 = res.package_items[2].ad_type_id;
                this.getSubTypes2();
                this.subselect2 = res.package_items[2].ad_sub_type_id;

                this.select3 = res.package_items[3].ad_type_id;
                this.getSubTypes3();
                this.subselect3 = res.package_items[3].ad_sub_type_id;
                this.last_package_item.map(() => {
                    this.sub2 = res.package_items[4].ad_sub_type_id;
                    this.sub3 = res.package_items[5].ad_sub_type_id;
                });
                this.isHidden = true;
                this.isHidden1 = true;
                this.isHidden2 = true;
            }
            if (this.PackageItems.length == 4) {
                this.addField(this.select, this.subselect);
                this.addField1(this.select1, this.subselect1);
                this.addField2(this.select2, this.subselect2);
                this.addField3(this.select3, this.subselect3);
                this.GetSubID(this.sub2);
                this.GetSubID2(this.sub3);
                this.default_values = '';
            }
            if (this.PackageItems.length == 3) {
                this.addField(this.select, this.subselect);
                this.addField1(this.select1, this.subselect1);
                this.addField2(this.select2, this.subselect2);
                this.GetSubID(this.sub2);
                this.GetSubID2(this.sub3);
                this.default_values = '';
            }
            if (this.PackageItems.length == 2) {
                this.addField(this.select, this.subselect);
                this.addField1(this.select1, this.subselect1);
                this.GetSubID(this.sub2);
                this.GetSubID2(this.sub3);
                this.default_values = '';
            }
            if (this.PackageItems.length == 1) {
                this.addField(this.select, this.subselect);
                this.GetSubID(this.sub2);
                this.GetSubID2(this.sub3);
                this.default_values = '';
            }

            // this.getSubTypes(this.ad_type_id)
            //     console.log(res);
            //     console.log(res.package_items);
            //     console.log(this.subselect);
            //     console.log(this.sub2);
        });
        this.packageService.GetUpgleTypeList().then((data) => {
            this.UpgleTypesdropdown = data.data.result;
            this.loading1 = false;
            // this.ad_type_id = data.data.id;
            // console.log(this.UpgleTypesdropdown)
            // console.log(this.ad_type_id)
        });
        this.packageService.GetTalentTypeList().then((data) => {
            this.TalentTypesdropdown = data.data.result;
            this.loading1 = false;
            // console.log(this.TalentTypesdropdown)
        });
        // this.packageService.GetAddSubTypeList(this.ad_type_id).then((res) => {
        //     this.SubTypesdropdown = res.data.result;
        //     this.grouparray = [];
        //     // this.ad_sub_type_id = res.package_items.ad_sub_type_id;
        //     console.log(res.data.result);
        // });
    },
    watch: {},
    methods: {
        getFRlist() {
            this.loading1 = true;
            this.freeService
                .getFreeList('5')
                .then((res) => {
                    this.results = res.data.result;
                    // this.totalrecords = res.data.total_records;
                    // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // console.log(res);
                })
                .catch((err) => console.log(err));
        },
        switchValue(ids, switchstatus) {
            console.log(ids, switchstatus);
            var self = this;
            axios({ method: 'post', url: '/api/v1/admin/package/change-status', data: { package_id: ids, status: switchstatus === false ? 'deleted' : 'active' } }).then(function (response) {
                // this.$router.push({ name: 'Banner Management' });
                self.$toast.add({ severity: 'info', summary: '확인.', detail: '패키지 정보가 변경되었습니다.', life: 3000 });
                console.log(response);
            });
        },
        // field: 0, ad_type_id: x, ad_sub_type_id: y
        // addOrReplace(arr, object) {
        //     var index = _.findIndex(arr, { ad_type_id: object.ad_type_id, ad_sub_type_id: object.ad_sub_type_id });
        //     if (-1 === index) {
        //         this.selected_items.push(object);
        //     } else {
        //         this.selected_items[index] = object;
        //     }
        // },
        addOrReplace(arry, obj) {
            let foundMatch = false;

            for (let i = 0; i < arry.length; i++) {
                if (arry[i].field === obj.field) {
                    //&& arry[i].ad_type_id === obj.ad_type_id && arry[i].ad_sub_type_id === obj.ad_sub_type_id
                    arry[i] = obj; // Replace the matching object with obj
                    foundMatch = true;
                    break;
                }
            }

            if (!foundMatch) {
                // const insertIndex = Math.max(0, arry.length - 2);
                arry.splice(-2, 0, obj);
                console.log(arry);
                console.log(obj);
                // arry.push(obj); // Push obj into arry if no match was found
                // arr.insert(arry.length - 2, obj)
            }

            return arry;
        },
        addField(x, y) {
            // fieldType.push({ value: '' });
            let res = { field: 0, ad_type_id: x, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }

            // this.isHidden = true;
        },
        removeField() {
            this.isHidden = false;
            // fieldType.splice(index, 1);
        },
        addField1(x, y) {
            // fieldType.push({ value: '' });
            let res = { field: 1, ad_type_id: x, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }
            // this.isHidden1 = true;
        },
        removeObjects(adTypeId, adSubTypeId) {
            this.selected_items = this.selected_items.filter((obj) => obj.ad_type_id !== adTypeId || obj.ad_sub_type_id !== adSubTypeId);
        },
        removeField1(adTypeId, adSubTypeId) {
            this.isHidden = false;
            // this.selected_items.splice(index, 1);
            this.selected_items = this.selected_items.filter((obj) => obj.ad_type_id !== adTypeId || obj.ad_sub_type_id !== adSubTypeId);
            console.log('this.selected_items----', this.selected_items);
            this.select1 = '';
            this.subselect1 = '';
            // fieldType.splice(index, 1);
        },
        addField2(x, y) {
            let res = { field: 2, ad_type_id: x, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }
            // this.isHidden2 = true;
            // fieldType.push({ value: '' });
        },
        removeField2(adTypeId, adSubTypeId) {
            this.isHidden1 = false;
            // this.selected_items.splice(index, 1);
            this.selected_items = this.selected_items.filter((obj) => obj.ad_type_id !== adTypeId || obj.ad_sub_type_id !== adSubTypeId);
            console.log('this.selected_items----', this.selected_items);
            this.select2 = '';
            this.subselect2 = '';
            // fieldType.splice(index, 1);
        },
        addField3(x, y) {
            let res = { field: 3, ad_type_id: x, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }
            // this.isHidden1 = true
            // fieldType.push({ value: '' });
        },
        removeField3(adTypeId, adSubTypeId) {
            this.isHidden2 = false;
            // this.selected_items.splice(index, 1);
            this.selected_items = this.selected_items.filter((obj) => obj.ad_type_id !== adTypeId || obj.ad_sub_type_id !== adSubTypeId);
            console.log('this.selected_items----', this.selected_items);
            this.select3 = '';
            this.subselect3 = '';
            // fieldType.splice(index, 1);
        },
        getSubTypes() {
            // console.log(this.select)
            this.packageService.GetAddSubTypeList(this.select).then((res) => {
                this.SubTypesdropdown = res.data.result;
                this.grouparray = [];
                // this.call = $event.target.value;
                // alert(this.call);
                console.log(this.SubTypesdropdown);
                // console.log(res.data.result);
            });
        },
        getSubTypes1() {
            // console.log(this.select)
            this.packageService.GetAddSubTypeList(this.select1).then((res) => {
                this.SubTypesdropdown1 = res.data.result;
                this.grouparray = [];
                // this.call = $event.target.value;
                // alert(this.call);
                // console.log(res.data.result);
                // console.log(res.data.result);
            });
        },
        getSubTypes2() {
            // console.log(this.select)
            this.packageService.GetAddSubTypeList(this.select2).then((res) => {
                this.SubTypesdropdown2 = res.data.result;
                this.grouparray = [];
                // this.call = $event.target.value;
                // alert(this.call);
                // console.log(res.data.result);
                // console.log(res.data.result);
            });
        },
        getSubTypes3() {
            // console.log(this.select)
            this.packageService.GetAddSubTypeList(this.select3).then((res) => {
                this.SubTypesdropdown3 = res.data.result;
                this.grouparray = [];
                // this.call = $event.target.value;
                // alert(this.call);
                console.log(res.data.result);
                // console.log(res.data.result);
            });
        },
        GetSubID(y) {
            // console.log(e.target.value)
            // console.log(e.target.getAttribute('data-type'))
            // console.log(e.target.selectedOptions[0].dataset.type);
            // this.grouparray.push(e.target.value);
            let res = { field: 4, ad_type_id: 6, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }

            // console.log(this.grouparray)
        },
        GetSubID2(y) {
            // console.log(e.target.value)
            // console.log(e.target.getAttribute('data-type'))
            // console.log(e.target.selectedOptions[0].dataset.type);
            // this.grouparray.push(e.target.value);
            let res = { field: 5, ad_type_id: 7, ad_sub_type_id: y };
            if (this.default_values == 'mounted') {
                this.selected_items.push(res);
            } else {
                this.addOrReplace(this.selected_items, res);
                console.log('this.selected_items----', this.selected_items);
            }

            // console.log(this.grouparray)
        },
        resetNotice() {
            this.notice_title = '';
            this.start_date = '';
            this.end_date = '';
            this.writer_name = '';
            this.sortByValue = 'id';
            this.sortOrderValue = 'desc';
            this.newnoticelist(); // for refresh the table data
        },
        getpercentage() {
            if (this.details.original_price && this.details.discount) {
                this.details.discounted_price = this.details.original_price - (this.details.discount / 100) * this.details.original_price;
            }
        },

        onFileChange(e) {
            // this.formData.delete('file');
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.file = files[0];
            var allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!allowedExtensions.exec(this.file.name)) {
                this.render1 = true;
                return false;
            } else {
                this.render1 = false;
                if (this.file.size > 26214400) {
                    // alert('파일이 너무 큽니다  ');
                    this.render2 = true;
                } else {
                    this.render2 = false;
                    this.fileName = this.file.name;
                    this.formData.append('image', files[0]);
                }
            }
            this.fileExtension = this.fileName.replace(/^.*\./, '');
            console.log(this.fileName);
        },
        LengthCheck() {
            let xyz = this.selected_items;
            console.log(this.selected_items)
            if (xyz.length >= 3 && xyz.some((obj) => obj.ad_type_id == 6) && xyz.some((obj) => obj.ad_type_id == 7)) {
                this.confirm(event);
                console.log('submit', xyz);
            } else {
                Swal.fire({
                    text: '상품 구성을 선택해 주세요.',
                    icon: 'error',
                    confirmButtonText: '확인',
                });
                // alert('Not Submitted')
                console.log('not_submit');
            }
        },

        confirm(event) {
            // confirm($event)

            // alert(this.mydata.notice_id)
            this.$confirm.require({
                target: event.currentTarget,
                group: 'popup',
                message: '계속 진행하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '확인',
                rejectLabel: '취소',
                accept: () => {
                    let vcheckData = {
                        discount: this.details.discount,
                        description: this.details.description,
                        modal_info: this.details.modal_info,
                        name: this.details.name,
                        original_price: this.details.original_price,
                        // discount: this.details.discount,
                        // discount: this.details.discount,
                        // status: this.status ? 'active' : 'inactive',
                        file: this.image == '' ? '' : 'something',
                    };
                    const { isInvalid, error } = validateEditPackage(vcheckData);
                    if (isInvalid) {
                        this.error = error;
                        console.log(error);
                    } else {
                        this.error = '';
                        // const Allpackage = [];
                        // let arr = [];
                        // arr.push(this.ad_type_id)
                        // for (let i = 0; i < this.package_items.length; i++) {
                        //     alert(this.package_items)
                        //     this.formData.append('ad_sub_types[ i ][ad_sub_type_id]', this.subselect);
                        // }
                        // this.formData.append('ad_sub_types', this.package_items);
                        // if (other_salary.status != 'no') {
                        // console.log(this.selected_items);
                        // console.log(this.last_package_item);
                        // var array3 = this.selected_items.concat(this.last_package_item);
                        var array3 = this.selected_items.sort((a, b) => a.field - b.field);
                        console.log('array3---', array3);

                        array3.forEach((res, id) => {
                            console.log('Response...', res);
                            this.formData.append(`ad_sub_types[${id}][ad_type_id]`, res.ad_type_id);
                            this.formData.append(`ad_sub_types[${id}][ad_sub_type_id]`, res.ad_sub_type_id);
                        });
                        console.log(array3.length);
                        // this.formData.append(`ad_sub_types[${id}][ad_type_id]`, res.ad_type_id);
                        // this.formData.append(`ad_sub_types[${id}][ad_sub_type_id]`, res.ad_sub_type_id);
                        // ad_sub_types[4][ad_type_id]:6
                        // ad_sub_types[4][ad_sub_type_id]:46
                        // ad_sub_types[5][ad_type_id]:7
                        // ad_sub_types[5][ad_sub_type_id]:55
                        // let PackageArray = [
                        //     {'ad_type_id':''},
                        //     {'ad_sub_type_id':''},
                        // ];
                        // for (var i = 0; i < PackageArray.length; i++) {
                        //     this.formData.append('ad_sub_types[]', PackageArray[i]);
                        // }
                        // }
                        // this.formData.append('ad_type_id', [this.select, 6, 7]);
                        this.formData.append('description', this.details.description);
                        this.formData.append('modal_info', this.details.modal_info);
                        // this.formData.append('ad_sub_type_id', [this.subselect, this.sub2, this.sub3]);
                        this.formData.append('discount', this.details.discount);
                        this.formData.append('discounted_price', this.details.discounted_price);
                        this.formData.append('original_price', this.details.original_price);
                        this.formData.append('name', this.details.name);
                        this.formData.append('package_id', this.$route.params.id);
                        // this.formData.append('status', this.details.status);
                        this.formData.append('status', this.details.status == '' ? 'inactive' : 'active');
                        // this.formData.append('type', this.dropdownValueType?.name === undefined ? this.type : this.dropdownValueType?.name);
                        console.log(this.formData);
                        return axios.post('/api/v1/admin/package/edit', this.formData).then((res) => {
                            // this.emergencyService.UpdateEmergency({ad_type_id:this.ad_type_id,description:this.details.description,modal_info:this.details.modal_info,status:this.details.status}).then((res) => {
                            console.warn(res);
                            console.log(this.formData);
                            this.$router.push({ name: 'Package' });
                            setTimeout(() => {
                                this.$toast.add({ severity: 'success', summary: '업데이트 완료', detail: '패키지 정보가 변경되었습니다.', life: 3000 });
                            }, 500);
                        });
                    }
                },
                // reject: () => {
                //     this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
                // },
            });
        },

        exceldownload() {
            this.productCategoryService.getExcel(this.first_category, this.second_category, this.third_category, this.productCategoryStatus?.code).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Productcategorylist.xlsx'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.start_date = utc;
            this.end_date = utc;
            this.getlist();
            console.log(this.start_date);
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            edate.setDate(edate.getDate());
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1).toString().padStart(2, '0') + '.' + date.getDate().toString().padStart(2, '0');
            const endDate = edate.getFullYear() + '.' + (edate.getMonth() + 1).toString().padStart(2, '0') + '.' + edate.getDate().toString().padStart(2, '0');
            this.start_date = startDate;
            this.end_date = endDate;
            this.getlist();
            console.log(this.start_date);
        },
        getParams(NotificationType) {
            localStorage.setItem('NotificationType', NotificationType);
            console.log(NotificationType);
        },
        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '.' + mm + '.' + dd);
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-col-12.p-mb-2.p-lg-6.p-mb-lg-0.p-field.d-flex {
    display: inline-flex;
}

label#switch {
    margin-right: 8px;
}

.img-info {
    font-size: 11px;
    font-weight: 400;
    color: rgb(48, 48, 48);
}

.product-image {
    padding-top: 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 5px;
    width: 150px !important;
    height: 100px;
    float: left;
}

.custom-select {
    position: relative;
    border: 1px solid #cecece;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

.select-file {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0%;
    z-index: 5;
    opacity: 0;
}

.SelectBtn {
    max-width: 100px;
}

.custom-select span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.custom-select-invalid {
    position: relative;
    border: 1px solid red;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
}

textarea#desc1 {
    height: 18vh;
}

.p-button {
    background: white;
    // border: 1px solid #0A0A0A;
    color: #0a0a0a;
}

select.DualDisplay2 {
    border: 1px solid #cecece;
    border-radius: 6px;
    width: 100%;
    height: 57%;
}

select.DualDisplay1 {
    border: 1px solid #cecece;
    border-radius: 6px;
    width: 100%;
    height: 35px;
}

select.DualDisplay2 {
    border: 1px solid #cecece;
    border-radius: 6px;
    width: 100%;
    height: 75%;
}
#Save {
    background: black;
    color: white;
}
div#tripple {
    display: flex;
    margin-top: 10px;
}
svg.ml-2.cursor-pointer {
    margin-top: 5px;
    margin-left: 5px;
}
label#match {
    margin-top: 1px;
}
.p-mt-25 {
    margin-top: 25px;
}
</style>
